var _circle, _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconInstagram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.312 5.3335H11.6893C8.18496 5.3335 5.33398 8.18448 5.33398 11.6888V20.3115C5.33398 23.8158 8.18496 26.6668 11.6893 26.6668H20.312C23.8163 26.6668 26.6673 23.8158 26.6673 20.3115V11.6888C26.6673 8.18448 23.8163 5.3335 20.312 5.3335ZM24.5212 20.3115C24.5212 22.6362 22.6366 24.5207 20.312 24.5207H11.6893C9.36465 24.5207 7.48012 22.6362 7.48012 20.3115V11.6888C7.48012 9.36412 9.36465 7.47963 11.6893 7.47963H20.312C22.6366 7.47963 24.5212 9.36412 24.5212 11.6888V20.3115Z",
    fill: "url(#paint0_linear_902_5901)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 10.4824C12.9576 10.4824 10.4824 12.9576 10.4824 15.9999C10.4824 19.0423 12.9576 21.5175 16 21.5175C19.0424 21.5175 21.5175 19.0423 21.5175 15.9999C21.5175 12.9576 19.0424 10.4824 16 10.4824ZM16 19.3714C14.138 19.3714 12.6286 17.862 12.6286 16C12.6286 14.138 14.138 12.6286 16 12.6286C17.862 12.6286 19.3714 14.138 19.3714 16C19.3714 17.8619 17.8619 19.3714 16 19.3714Z",
    fill: "url(#paint1_linear_902_5901)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5292 11.8464C22.2593 11.8464 22.8513 11.2545 22.8513 10.5243C22.8513 9.79408 22.2593 9.20215 21.5292 9.20215C20.799 9.20215 20.207 9.79408 20.207 10.5243C20.207 11.2545 20.799 11.8464 21.5292 11.8464Z",
    fill: "url(#paint2_linear_902_5901)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_902_5901",
    x1: 16.0007,
    y1: 26.6047,
    x2: 16.0007,
    y2: 5.4992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E09B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#C74C4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#C21975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7024C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_902_5901",
    x1: 16,
    y1: 26.6045,
    x2: 16,
    y2: 5.49902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E09B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#C74C4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#C21975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7024C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_902_5901",
    x1: 21.5292,
    y1: 26.605,
    x2: 21.5292,
    y2: 5.49944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E09B3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#C74C4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#C21975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7024C4"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInstagram);
export default __webpack_public_path__ + "static/media/icon_instagram.f9aaa0e917a8418f304d53de72c8665c.svg";
export { ForwardRef as ReactComponent };